import { makeStyles } from "@material-ui/styles";
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
  toastsContainer: {
    width: 400,
    marginTop: theme.spacing(6),
    right: 0,
  },
  progress: {
    visibility: "hidden",
  },
  notification: {
    display: "flex",
    alignItems: "center",
    background: "transparent",
    boxShadow: "none",
    overflow: "visible",
  },
  notificationComponent: {
    paddingRight: theme.spacing(4),
  },
  reportSubtitle: {
      paddingLeft: '10px',
      width: '100%',
      paddingBottom: '10px',
      fontWeight: '600 !important'
  },
  uploadCalendars: {
    marginBottom: '20px',
    '& > *': {
        minWidth: '150px',
        paddingBottom: '10px'
    },
    '& > :first-child': {
      marginRight: '10px'
    }
  },
}));
